import { toast } from "react-toastify";

export const errorHandler = (mgs, errorDetails) => {
  return toast.error(
    <>
      <div>⚠️​ {mgs}.</div>
      <div>{errorDetails}</div>
    </>,
    {
      position: "top-right",
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: 0,
    }
  );
};
